var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOthers({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.6268 9.50675C27.6268 10.8596 27.2256 12.182 26.474 13.3068C25.7224 14.4317 24.6542 15.3084 23.4043 15.8261C22.1545 16.3438 20.7792 16.4792 19.4524 16.2153C18.1255 15.9514 16.9068 15.2999 15.9502 14.3434C14.9936 13.3868 14.3421 12.168 14.0782 10.8412C13.8143 9.51434 13.9497 8.13904 14.4674 6.88919C14.9851 5.63935 15.8618 4.57108 16.9867 3.8195C18.1115 3.06791 19.434 2.66675 20.7868 2.66675C22.6009 2.66675 24.3406 3.38739 25.6234 4.67014C26.9061 5.95289 27.6268 7.69267 27.6268 9.50675V9.50675Z",
    stroke: "#A5A7B8",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5869 21.8135C12.5869 22.6257 12.346 23.4197 11.8948 24.095C11.4435 24.7703 10.8022 25.2967 10.0518 25.6075C9.30136 25.9183 8.47565 25.9997 7.67903 25.8412C6.88242 25.6828 6.15068 25.2916 5.57635 24.7173C5.00202 24.143 4.6109 23.4112 4.45245 22.6146C4.29399 21.818 4.37531 20.9923 4.68614 20.2419C4.99696 19.4915 5.52332 18.8501 6.19866 18.3989C6.874 17.9476 7.66798 17.7068 8.4802 17.7068C9.56936 17.7068 10.6139 18.1395 11.3841 18.9096C12.1542 19.6798 12.5869 20.7243 12.5869 21.8135Z",
    stroke: "#A5A7B8",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.5733 25.9199C25.5733 26.595 25.3731 27.255 24.998 27.8163C24.6229 28.3776 24.0898 28.8151 23.4661 29.0734C22.8424 29.3318 22.1561 29.3994 21.494 29.2677C20.8319 29.136 20.2237 28.8109 19.7463 28.3335C19.269 27.8562 18.9439 27.248 18.8122 26.5858C18.6805 25.9237 18.7481 25.2374 19.0064 24.6137C19.2648 23.99 19.7023 23.4569 20.2636 23.0818C20.8249 22.7068 21.4848 22.5066 22.1599 22.5066C23.0652 22.5066 23.9334 22.8662 24.5735 23.5063C25.2136 24.1465 25.5733 25.0147 25.5733 25.9199V25.9199Z",
    stroke: "#A5A7B8",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOthers);
export default __webpack_public_path__ + "static/media/Others.d38133e2.svg";
export { ForwardRef as ReactComponent };